
const Footer = ({ children }) =>
  <footer className="site-footer">
    { children }
  </footer>

export default Footer